module.exports = __webpack_public_path__ + "static/media/Black-Primary.0da56bbe.svg";